import { useDispatch } from 'react-redux'
import styles from './taskComponent.module.css'
import { toastHelper } from '../../util/toastHelper'

export const TaskItem = ({
	task,
	setEditingTask,
	setConfirmDeleteId,
	staff,
}) => {
	const dispatch = useDispatch()

	const onToggleComplete = (task) => {
		// if (!staff) {
		// 	return dispatch(
		// 		editTask({
		// 			taskId: task._id,
		// 			updates: {
		// 				completed: !task.completed,
		// 				waitingForApproval: false,
		// 			},
		// 		})
		// 	)
		// }

		if (!task.completed && !task.waitingForApproval) {
			toastHelper(
				'Task completion has been sent to vendor for approval',
				'success'
			)
			// dispatch(
			// 	editTask({
			// 		taskId: task._id,
			// 		updates: { waitingForApproval: true },
			// 	})
			// )
		}
	}

	return (
		<div key={task._id} className={styles.row}>
			<div
				className={`${styles.nameCell} ${task.completed ? styles.completedText : ''}`}
			>
				{task.name}
			</div>
			<div>{task.type || '—'}</div>
			<div className={styles.actionsCol}>
				<button
					className={`${task.completed ? styles.iconBtnc : task.waitingForApproval ? styles.iconBtnWFA : styles.iconBtnNc}`}
					onClick={() => onToggleComplete(task)}
					data-cy="markTaskAsComplete"
				>
					✔︎
				</button>
				{setEditingTask && (
					<button
						className={styles.iconBtn}
						title="Edit"
						onClick={() => setEditingTask(task)}
						data-cy="editTask"
					>
						✏️
					</button>
				)}
				{setConfirmDeleteId && (
					<button
						className={`${styles.iconBtn} ${styles.danger}`}
						title="Delete"
						onClick={() => setConfirmDeleteId(task._id)}
						data-cy="deleteTask"
					>
						🗑
					</button>
				)}
			</div>
		</div>
	)
}
